import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { CourseCard } from "@/components/Cards";
import { Disclaimer } from "@/components/Shared";

const FILTERS = ["All", "Beginner", "Intermediate", "Advanced", "Options Trading", "Options & Futures", "Trading Strategies", "Chart Patterns", "Candlestick Patterns", "Trading Indicators"];

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = courses.filter((c) => active === "All" || c.level === active || c.category === active);

  return (
    <div data-testid="courses-page">
      <PageHero
        eyebrow="Courses"
        title="Financial-Market Courses"
        subtitle="Learn financial-market concepts through structured courses covering technical analysis, market structure, derivatives, options and futures, CPR and Pivot Points, Open Interest, PCR, trading psychology, risk management and systematic methodologies."
        crumbs={[{ label: "Courses" }]}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <div className="rounded-lg border border-gold/40 bg-gold/5 p-4 text-sm text-slate-600" data-testid="courses-educational-notice">
          <span className="font-semibold text-navy">Educational Notice:</span> The courses on KRV Prime are educational in nature. Examples, methodologies and strategy frameworks explain financial-market concepts and should not be interpreted as personalised investment advice or a guarantee of future performance.
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex flex-wrap gap-2 mb-10" data-testid="course-filters">
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`filter-${f.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setActive(f)}
              className={`text-sm px-4 py-2 rounded-md border transition-colors ${
                active === f ? "bg-navy text-white border-navy" : "bg-white text-slate-600 border-border hover:border-navy/40"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
        {loading ? (
          <p className="text-slate-400">Loading courses…</p>
        ) : filtered.length === 0 ? (
          <p className="text-slate-400" data-testid="no-courses">No courses match this filter.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((c) => <CourseCard key={c.slug} course={c} />)}
          </div>
        )}
        <div className="mt-14"><Disclaimer /></div>
      </div>
    </div>
  );
}
